<template>
  <div>
    <a-row type="flex">
      <a-col :span="8">
        <div style="display:flex;margin-bottom:5px">
          <span class="span-duty">驾校名称</span>
          <a-select
            allowClear
            showSearch
            placeholder="请选择驾校"
            :filterOption="filterOption"
            style="width:165px"
            v-model="drivschid"
          >
            <a-select-option
              :value="item.value"
              v-for="(item,idx) in drivschList"
              :key="idx"
            >{{item.label}}</a-select-option>
          </a-select>
        </div>
        <a-input
          style="width:225px;margin-bottom:5px"
          addonBefore="证件编号"
          placeholder="请输入证件编号"
          v-model="idno"
        />
        <a-input style="width:225px;" addonBefore="学员姓名" placeholder="学员姓名" v-model="stuname" />
      </a-col>
      <a-col :span="8">
        <div style="display:flex;margin-bottom:5px">
          <span class="span-duty">到账状态</span>
          <a-select
            allowClear
            showSearch
            placeholder="到账状态"
            :filterOption="filterOption"
            style="width:165px"
            v-model="supstate"
          >
            <a-select-option value="00">00-未到账</a-select-option>
            <a-select-option value="01">01-已到账</a-select-option>
            <a-select-option value="02">02-已撤销</a-select-option>
            <a-select-option value="03">03-已退货</a-select-option>
          </a-select>
        </div>
        <div style="display:flex;">
          <span class="span-duty">退款状态</span>
          <a-select
            allowClear
            showSearch
            placeholder="退款状态"
            :filterOption="filterOption"
            style="width:165px"
            v-model="refstatus"
          >
            <a-select-option value="00">00-未退款</a-select-option>
            <a-select-option value="01">01-已退款</a-select-option>
          </a-select>
        </div>
      </a-col>
      <a-col :span="8">
        <div style="display:flex;margin-bottom:5px">
          <span class="span-duty">报送日期</span>
          <a-range-picker
            :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
            @change="reqDateChange"
            :format="dateFormat"
            v-model="req_date_format"
            style="width:200px"
          />
        </div>
        <div style="display:flex;margin-bottom:5px">
          <span class="span-duty">到账日期</span>
          <a-range-picker
            :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
            @change="supDateChange"
            :format="dateFormat"
            style="width:200px"
          />
        </div>
        <div style="display:flex;">
          <span class="span-duty">退款日期</span>
          <a-range-picker
            :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
            @change="refDateChange"
            :format="dateFormat"
            style="width:200px"
          />
        </div>
      </a-col>
    </a-row>
    <div style="text-align:center;margin-top:5px">
      <a-button type="primary" style="margin-left:16px;" icon="search" @click="()=>{this.pagination.current = 1;getPersonList()}">查询</a-button>
    </div>
    <j-table
      :tableColumns="columns"
      :rowKey="record => record.contno"
      :tableData="tableData"
      :loading="loading"
      :slotWidth="0"
      :tablePagination="pagination"
      v-on:onOrderbyChange="(newOrderby)=>{ orderby = newOrderby;getPersonList(); }"
      v-on:onPaginationChange="(newPagination)=>{ pagination = newPagination;getPersonList(); }"
      style="margin-top:10px"
    >
      <template v-slot="record">
        <div
          style="display:flex;flex-direction: row;justify-content:space-around;align-items:center"
        >
          <a @click="()=>{contractDetailsVisble = true;contractDetails=record}">详情</a>
        </div>
      </template>
    </j-table>
    <ContractDetails
      v-if="contractDetailsVisble"
      :contractDetails="contractDetails"
      v-on:close="()=>{contractDetailsVisble=false}"
    />
  </div>
</template>
<script>
import JTable from "../../components/JTable";
import moment from "moment";
import ContractDetails from "../../components/ContractDetails";

const columns = [
  {
    title: "合同编号",
    dataIndex: "contno",
    key: "contno",
    fixed: "left",
    align: "center",
    sorter: true,
    width: 230
  },
  {
    title: "学员姓名",
    dataIndex: "stuname",
    key: "stuname",
    align: "center",
    fixed: "left",
    width: 120
  },
  { title: "学员性别", 
  dataIndex: "sex", 
  key: "sex", 
  align: "center",
  width: 100
  },
  
  {
    title: "驾协名称",
    dataIndex: "drivasstiddesc",
    key: "drivasstiddesc",
    align: "center",
    width: 170
  },
  {
    title: "驾校名称",
    dataIndex: "drivschiddesc",
    key: "drivschiddesc",
    align: "center",
    width: 170
  },
  {
    title: "请求日期",
    dataIndex: "reqdate",
    key: "reqdate",
    align: "center",
    width: 120
  },
  {
    title: "证件号码",
    dataIndex: "idno",
    key: "idno",
    align: "center",
    width: 170
  },
  {
    title: "证件类型",
    dataIndex: "idtype_desc",
    key: "idtype_desc",
    align: "center",
    width: 120
  },
  {
    title: "手机号码",
    dataIndex: "contactsmobile",
    key: "contactsmobile",
    align: "center",
    width: 170
  },
  {
    title: "驾照类型",
    dataIndex: "drivertype",
    key: "drivertype",
    align: "center",
    width: 170
  },
  {
    title: "合同签订日期",
    dataIndex: "dateofsign",
    key: "dateofsign",
    align: "center",
    width: 120
  },
  {
    title: "合同状态",
    dataIndex: "constate",
    key: "constate",
    align: "center",
    customRender: function(text) {
      return text == "00" ? "生效状态" : "人工解除";
    },
    width: 120
  },
  
  {
    title: "到账状态",
    dataIndex: "supstate",
    key: "supstate",
    align: "center",
    customRender: function(text) {
       return text == "00"
        ? "未到账"
        : text == "01"
        ? "已到账"
        : text == "02"
        ? "已撤销"
        : text == "03"
        ? "已退货"
        : text;
    },
    width: 170
  },
  {
    title: "到账日期",
    dataIndex: "supdate",
    key: "supdate",
    align: "center",
    width: 150
  },
  {
    title: "合同总金额",
    dataIndex: "constamt",
    key: "constamt",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "合同总学时金额",
    dataIndex: "tuition",
    key: "tuition",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "教材金额",
    dataIndex: "other1",
    key: "other1",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "档案金额",
    dataIndex: "other2",
    key: "other2",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "代收一卡通金额",
    dataIndex: "other3",
    key: "other3",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "代收考试金额",
    dataIndex: "other4",
    key: "other4",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "其他代收金额",
    dataIndex: "other5",
    key: "other5",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "合同总科目学时",
    dataIndex: "conclasshour",
    key: "conclasshour",
    align: "center",
    width: 100
  },
  {
    title: "合同总科目基本学时",
    dataIndex: "classhour",
    key: "classhour",
    align: "center",
    width: 100
  },
  {
    title: "预付培训费金额",
    dataIndex: "suptution",
    key: "suptution",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "已支付学时",
    dataIndex: "timepaied",
    key: "timepaied",
    align: "center",
    width: 100
  },
  {
    title: "已支付金额",
    dataIndex: "feepaid",
    key: "feepaid",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "在途金额",
    dataIndex: "onpayamt",
    key: "onpayamt",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "溢出学时",
    dataIndex: "timesplil",
    key: "timesplil",
    align: "center",
    width: 100
  },
  {
    title: "退款状态",
    dataIndex: "refstatus",
    key: "refstatus",
    align: "center",
    width: 120
  },
  {
    title: "退款金额",
    dataIndex: "refamt",
    key: "refamt",
    align: "center",
    width: 100,
    customRender:function(text){
      if(!text) return '0.00';
      return parseFloat(text/100).toFixed(2)
    }
  },
  {
    title: "退款平台日期",
    dataIndex: "refdate",
    key: "refdate",
    align: "center",
    width: 150
  },
  {
    title: "学员邮箱",
    dataIndex: "contactsemail",
    key: "contactsemail",
    align: "center",
    width: 170
  },
  {
    title: "学员联系方式",
    dataIndex: "contactaddress",
    key: "contactaddress",
    align: "center",
    width: 170
  },
  {
    title: "学员其他联系方式",
    dataIndex: "othercontacttype",
    key: "othercontacttype",
    align: "center",
    width: 170
  },


  {
    title: "操作",
    key: "operation",
    scopedSlots: { customRender: "operation" },
    align: "center",
    fixed: "right",
    width: 80
  }
];
export default {
  name: 'ContractInfor',
  components: {
    JTable,
    ContractDetails
  },
  data() {
    return {
      drivasstid: this.$cache.session.get(this.$marco.constants.KEY_ORG_ID),
      columns,
      tableData: [],
      dateFormat: "YYYY-MM-DD",
      req_date_format: [
        moment(moment().subtract(3, "days"), "YYYY-MM-DD"),
        moment(moment(), "YYYY-MM-DD")
      ],
      sup_date_format: [
        moment(moment(), "YYYY-MM-DD"),
        moment(moment(), "YYYY-MM-DD")
      ],
      pagination: {
        pageSize: 20,
        pageSizeOptions: ["1", "10", "20", "30", "50"],
        current: 1,
        total: 0
      },
      orderby: "contno desc",
      loading: false,
      contno: "",
      dateofsign: "",
      contractDetailsVisble: false,
      contractDetails: {},
      drivasstList: [],
      drivschList: [],
      drivschid: "",
      idno: "",
      stuname: "",
      start_req_date: moment()
        .subtract(3, "days")
        .format("YYYYMMDD"),
      end_req_date: moment().format("YYYYMMDD"),
      start_sup_date: "",
      end_sup_date: "",
      start_ref_date: "",
      end_ref_date: "",
      refstatus: "",
      supstate: ""
    };
  },
  created() {
    this.getPersonList();
    this.fetchDrivsch();
  },
  methods: {
      moment,
    getPersonList() {
      const that = this;
      if (
        (that.start_req_date && that.end_req_date) ||
        (that.start_sup_date && that.end_sup_date) ||
        (that.start_ref_date && that.end_ref_date)
      ) {
      } else {
        that.$message.error("三个日期条件至少输入一个");
        return;
      }
      that.tableData = [];
      const reqData = {
        currpage: that.pagination.current,
        orderby: that.orderby,
        recnumperpage: that.pagination.pageSize,
        // contno: that.contno
        drivasstId: that.drivasstid,
        drivschid: that.drivschid,
        idno: that.idno,
        stuname: that.stuname,
        supstate: that.supstate,
        refstatus: that.refstatus,
        beginDate: that.start_req_date,
        endDate: that.end_req_date,
        start_sup_date: that.start_sup_date,
        end_sup_date: that.end_sup_date,
        start_ref_date: that.start_ref_date,
        end_ref_date: that.end_ref_date
      };
      that.$http.post(
        that.$marco.api.personList,
        reqData,
        data => {
          this.$log.success(JSON.stringify(data));

          that.tableData = that.tableData.concat(data.pagelist);
          that.pagination.total = data.recnum;
        },
        errorDesc => {
          this.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          this.$log.error(JSON.stringify(error));
        },
        that
      );
    },
    fetchDrivsch() {
      const that = this;
      that.$http.post(
        that.$marco.api.schoolId,
        { drivasstid: that.drivasstid },
        data => {
          this.$log.success("驾校列表" + JSON.stringify(data));
          that.drivschList = [];
          data.map(item => {
            that.drivschList.push({
              label: item.drivschname,
              value: item.drivschid
            });
          });
        },
        errorDesc => {
          this.$log.normal("驾协列表" + JSON.stringify(errorDesc));
        },
        error => {
          this.$log.error("驾协列表" + JSON.stringify(error));
        },
        that
      );
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    reqDateChange(date, dateString) {
      this.start_req_date = dateString[0]
        ? moment(dateString[0]).format("YYYYMMDD")
        : "";
      this.end_req_date = dateString[1]
        ? moment(dateString[1]).format("YYYYMMDD")
        : "";
    },
    supDateChange(date, dateString) {
      this.start_sup_date = dateString[0]
        ? moment(dateString[0]).format("YYYYMMDD")
        : "";
      this.end_sup_date = dateString[1]
        ? moment(dateString[1]).format("YYYYMMDD")
        : "";
    },
    refDateChange(date, dateString) {
      this.start_ref_date = dateString[0]
        ? moment(dateString[0]).format("YYYYMMDD")
        : "";
      this.end_ref_date = dateString[1]
        ? moment(dateString[1]).format("YYYYMMDD")
        : "";
    }
  }
};
</script>
<style scoped>
.span-duty {
  padding: 0 11px;
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-bottom-left-radius: 4px;
  border-top-left-radius: 4px;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  border-right: 0;
  height: 32px;
  font-size: 14px;
  line-height: 1.5;
  display: flex;
  align-items: center;
}
</style>